/**
 * Reads supportChatEnabled flag from the logged-in client's doc.
 * Admins are ALWAYS enabled (they test the feature).
 *
 * Returns {enabled, loading}. Default (no flag set) is FALSE — this is the
 * gate for the gradual rollout.
 */

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useAuth } from '../../hooks/useAuth';
import { useAdmin } from '../../hooks/useAdmin';

export function useSupportChatEnabled(): { enabled: boolean; loading: boolean } {
  const { user } = useAuth();
  const { isAdmin } = useAdmin();
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setEnabled(false);
      setLoading(false);
      return;
    }
    if (isAdmin) {
      setEnabled(true);
      setLoading(false);
      return;
    }
    const ref = doc(db, 'clients', user.uid);
    const unsub = onSnapshot(ref, snap => {
      setEnabled(Boolean(snap.data()?.supportChatEnabled));
      setLoading(false);
    });
    return unsub;
  }, [user, isAdmin]);

  return { enabled, loading };
}
